export const loginType = {
  Team: 'Team',
  Avatar: 'Avatar',
  System: 'System',
};
